import { useGetQuery } from 'Hooks/useGetQuery';
import { CustomerType, ResponseType } from 'Types/common';

export const useGetUserCustomerData = (): CustomerType => {
  const data = useGetQuery(['useFetchGetCustomers']) as ResponseType<CustomerType>;
  const info = data?.data;
  return info?.item;
};
